export default __webpack_public_path__ + "static/media/city-picture-border.54f61811.svg";